import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import CustomNavigate from '../components/CustomNavigate';

export default function AdminMiddleware({ children }) {
    const { user } = useAuth();

    if (user?.role !== 'admin') return <CustomNavigate to="/dashboard/home" />; 

    return children; 
}

AdminMiddleware.propTypes = {
    children: PropTypes.node.isRequired,
};
